<template>
  <div>
    <div class="form_item" :class="save_to+'_wrapper'">
      <Label :required="required" :label="label" :for_id="save_to"/>
      <div :id="save_to+'_element'">
        <label v-for="(option, index) in options" :key="index">
          <input 
            type="radio"
            :v-validate="required ? 'required' : undefined"
            :required="required"
            :name="`radio_${save_to}`"
            v-model="val"
            :value="(option.value !== undefined)?option.value:option.toLowerCase()"/>
          <span data-text="*" v-html="option.value !== undefined?option.name:option"></span>
        </label>
      </div>
      <p v-if="info !== undefined" class="info" v-html="info"></p>
      <div class="error_container">
        <span
          class="error"
          v-show="errors.has(validationLabel || label) && ((fields[validationLabel || label].untouched && !fields[validationLabel || label].dirty) || (fields[validationLabel || label].touched && fields[validationLabel || label].dirty))"
          v-text="errors.first(validationLabel || label)"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import { validatorComponent } from './validatorComponentMixin';
import Label from './Label'

export default {
  name: 'Input',
  mixins: [validatorComponent],
  data: function () {
    return {

    }
  },
  components: {
    Label
  },
  props: {
    label: String,
    validationLabel: String,
    options: {
      type: Array,
      required: true
    },
    save_to: String,
    required: Boolean,
  },
  created() {

  },
  computed: {
    confirmationName () {
      return this.save_to + '_confirmation';
    }
  }
};
</script>
